<template>
  <section class="mc-rec-ord-group" :class="'mc-rec-ord-group--' + variant">
    <div class="mc-rec-ord-group__head">
      <span v-if="icon" class="mc-rec-ord-group__icon" aria-hidden="true">{{ icon }}</span>
      <h3 class="mc-rec-ord-group__title">{{ title }} ({{ items.length }})</h3>
    </div>
    <div class="mc-rec-ord-group__list">
      <slot :display-items="displayItems" />
    </div>
    <button
      v-if="items.length > collapseAt"
      type="button"
      class="mc-rec-ord-group__more"
      @click="expanded = !expanded"
    >
      {{ expanded ? 'Mostrar menos' : 'Mostrar mais produtos' }}
    </button>
  </section>
</template>

<script>
export default {
  name: 'RecommendationGroupSection',
  props: {
    title: { type: String, required: true },
    variant: {
      type: String,
      default: 'neutral',
      validator: v => ['converted', 'recommended', 'spontaneous'].includes(v),
    },
    icon: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    collapseAt: { type: Number, default: 6 },
  },
  data() {
    return { expanded: false }
  },
  computed: {
    displayItems() {
      if (this.items.length <= this.collapseAt || this.expanded) return this.items
      return this.items.slice(0, this.collapseAt)
    },
  },
  watch: {
    items() {
      this.expanded = false
    },
  },
}
</script>
